/**
 * @generated SignedSource<<afd78c9c5f1446250b8a255671317ce3>>
 * @relayHash 6159df47506c760bc9d3bcb347c7de4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ba454c25ab6b2a91a8f66bf3811c0d9d12e24802b9f7ba7700b299fc78694f7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CustomerDetailsPageQuery } from './CustomerDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<CustomerDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1ba454c25ab6b2a91a8f66bf3811c0d9d12e24802b9f7ba7700b299fc78694f7",
    "metadata": {},
    "name": "CustomerDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
